import { render, staticRenderFns } from "./invoice-history-list.vue?vue&type=template&id=4a52d4f2&scoped=true"
import script from "./invoice-history-list.vue?vue&type=script&lang=js"
export * from "./invoice-history-list.vue?vue&type=script&lang=js"
import style0 from "./invoice-history-list.vue?vue&type=style&index=0&id=4a52d4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a52d4f2",
  null
  
)

export default component.exports